// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tag-selector {
  line-height: 1.15;
}
.tag-selector .pui-form-type-ahead-input-async-multi-select {
  max-height: 40px;
  overflow: hidden;
  overflow-y: auto;
}
.tag-selector__button {
  display: flex;
  justify-content: right;
  margin: 0.64rem 0 1.6rem;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
